"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryParamKeys = void 0;
var QueryParamKeys;

(function (QueryParamKeys) {
  QueryParamKeys["PAGE"] = "page";
  QueryParamKeys["LIMIT"] = "limit";
  QueryParamKeys["STATUS"] = "status";
  QueryParamKeys["CREATED_FROM"] = "from";
  QueryParamKeys["CREATED_TO"] = "to";
  QueryParamKeys["DELETED_FROM"] = "deletedFrom";
  QueryParamKeys["DELETED_TO"] = "deletedTo";
  QueryParamKeys["DUE_FROM"] = "dueFrom";
  QueryParamKeys["DUE_TO"] = "dueTo";
  QueryParamKeys["AMOUNT_FROM"] = "amountFrom";
  QueryParamKeys["AMOUNT_TO"] = "amountTo";
  QueryParamKeys["SEARCH_KEYWORD"] = "searchKeyword";
  QueryParamKeys["SORT_KEY"] = "sort";
  QueryParamKeys["SORT_DIRECTION"] = "sortDirection";
  QueryParamKeys["FILTER_FIELD"] = "filter";
  QueryParamKeys["FILTER_VALUE"] = "filterValue";
  QueryParamKeys["COMPLETED_FROM"] = "completedFrom";
  QueryParamKeys["COMPLETED_TO"] = "completedTo";
  QueryParamKeys["DIRECTION"] = "direction";
})(QueryParamKeys = exports.QueryParamKeys || (exports.QueryParamKeys = {}));